module.exports = __webpack_public_path__ + "img/icon-calendar-week.32cd5afb.svg";